import { ChangeDetectorRef, Component, signal } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
// import { environment } from '~src/environments/environment';
import { LoaderComponent } from "./modules/services/loader/templates/loader/loader.component";

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.html',
    styleUrls: ['./app.scss']
})
export class App {
    loading = true;
    protected readonly title = signal('mc_mcs_merchant_web');
    constructor(
        private router: Router,
        private cdr: ChangeDetectorRef,
    ) {
        this.router.events
            .pipe(filter((event: any) => event instanceof NavigationEnd))
            .subscribe(() => {
                this.loading = false;
                this.cdr.detectChanges();
            });

        this.router.events
            .pipe(
                filter(
                    (event: any) =>
                        event instanceof NavigationCancel ||
                        event instanceof NavigationError
                )
            )
            .subscribe(() => {
                this.loading = false;
                // this.cdr.detectChanges();
            });
    }
    
    ngAfterViewInit(): void {
        // const container = document.getElementById('loader-container');
        // if (container) {
        //     const div = document.createElement('div');
        //     div.innerText = 'Loading...';
        //     container.appendChild(div);
        // } else {
        //     console.warn('loader-container not found!');
        // }
        // this.loadMastercardSdk().then(() => {
        //     console.log('Mastercard SDK is ready to use.');
        // }).catch((err) => {
        //     console.error('Error loading Mastercard SDK:', err);
        // });
    }
    // private loadMastercardSdk(): Promise<void> {
    //     return new Promise((resolve, reject) => {
    //         if (document.getElementById('mc-sdk')) {
    //             resolve();
    //             return;
    //         }

    //         const script = document.createElement('script');
    //         script.id = 'mc-sdk';
    //         script.type = 'text/javascript';
    //         script.src = environment.scofSDK;
    //         script.async = true;

    //         script.onload = () => {
    //             console.log('Mastercard SDK loaded');
    //             resolve();
    //         };

    //         script.onerror = (err) => {
    //             console.error('Failed to load Mastercard SDK', err);
    //             reject(err);
    //         };

    //         document.head.appendChild(script);  // ✅ safe to append here
    //     });
    // }
}
